
import { getUrlApi } from '../utilities/util';
import ApiHandler from './ApiHandlers/ApiHandler'; 
 
export const baseURL = String(getUrlApi());

export default class DeviceParamApi { 

    static async GetDeviceParamById(culture : string, id: number): Promise<any> {
        return ApiHandler(baseURL).get(culture + "/deviceparam/getdeviceparambyid" + id);
    };  
    

    static async GetDeviceParamsByDeviceId(id: string): Promise<any> {
        return ApiHandler(baseURL).get(`/deviceparam/getdeviceparamsbydeviceid?deviceId=${id}`);
    }; 


    static async CreateDeviceParam(deviceParamData: { 
        deviceId: string; 
        paramKey: string; 
        paramValue: string;
        description: string;
        active: boolean

     }): Promise<any> {
        return ApiHandler(baseURL).post("/deviceparam/deviceparamcreate", deviceParamData);
    }

    static async UpdateDeviceParam(deviceParamData: { 
        id:string;
        deviceId: string; 
        paramKey: string; 
        paramValue: string; 
        description: string;
        active: boolean
    }): Promise<any> {

        return ApiHandler(baseURL).post(`/deviceparam/deviceparamupdate`, deviceParamData); 
    }

    

    static async DeleteDeviceParam(id: string): Promise<any> {
        return ApiHandler(baseURL).post(`/deviceparam/deviceparamdelete`, id, {
            headers: {
                'Content-Type': 'application/json-patch+json',
            },
        });
    }
    
}
